<template>
    <table class="table table-striped table-hover table-responsive-md text-center">
        <thead>
            <tr>
                <th>{{ $t("vehicleNfcEntry.licencePlate") }}</th>
                <th>{{ $t("vehicleNfcEntry.name") }}</th>
                <th>{{ $t("vehicleNfcEntry.arrived") }}</th>
                <th>{{ $t("vehicleNfcEntry.left") }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody v-if="entryList.length">
            <tr
                v-for="entry in entryList"
                :key="entry.id"
                class="align-middle"
            >
                <td>{{ entry.licence_plate_snapshot || "—" }}</td>
                <td>{{ entry.name_snapshot || "—" }}</td>
                <td>
                    {{ entry.arrived_at ? $d(new Date(entry.arrived_at), 'short') : "—" }}
                </td>
                <td>
                    {{ entry.left_at ? $d(new Date(entry.left_at), 'short') : "—" }}
                </td>
                <td>
                    <button
                        class="btn btn-primary btn-sm"
                        @click="goToDetail(entry.id)"
                    >
                        <Icon icon="Search"></Icon>
                    </button>
                </td>
            </tr>
        </tbody>

        <tbody v-else>
            <tr>
                <td colspan="5" class="text-center text-muted py-3">
                    {{ $t("vehicleNfcEntry.notFound") }}
                </td>
            </tr>
        </tbody>
    </table>

    <div v-if="totalCount > 0" class="d-flex justify-content-between mx-4">
        <Paginate
            :page-count="totalPages"
            :click-handler="p => $emit('page-change', p)"
            :prev-text="'«'"
            :next-text="'»'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :active-class="'active'"
            :disabled-class="'disabled'"
        />

        <div class="flex-shrink-0">
            <select
                class="form-select form-select-sm"
                style="height: 40px;"
                :value="perPage"
                @change="$emit('per-page-change', Number($event.target.value))"
            >
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
            </select>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        page: {
            type: Number,
            default: 1,
        },
        perPage: {
            type: Number,
            default: 10,
        },
    },
    methods: {
        goToDetail(entryId) {
            this.$router.push({
                name: "vehicleNfcEntryDetailView",
                params: {
                    slug: this.$route.params.slug,
                    id: entryId,
                }
            });
        },
    },
    computed: {
        entryList() {
            return this.items;
        },
        totalPages() {
            return Math.ceil(this.totalCount / this.perPage);
        }
    }
}
</script>

<style scoped>
table {
    table-layout: fixed;
}
</style>
